const labels = {
  All: { 'See the offering': 'Veja a oferta' },
  FacilityDetails: { 'Ref: Page title': 'Detalhes da Instalação', 'Ref: Review': 'Análise' },
  FacilitiesList: { 'Ref: Page title': 'Instalações', 'Ref: See details': 'Veja detalhes' },
};
export default labels;
